export default "__VITE_ASSET__4f4b1946__"